import {useEffect} from 'react'
import {useHistory} from 'react-router'

export function ResetPassword() {
  const history = useHistory()

  useEffect(() => {
    history.replace('/auth/forgotpassword')
  }, [history])

  return null
}
